module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "filled": "",
      "persistent-hint": "",
      "clearable": "",
      "prefix": _vm.$store.getters.settings.currency,
      "label": _vm.$t('inputs.opening.label'),
      "hint": _vm.$t('inputs.opening.hint')
    },
    model: {
      value: (_vm.openingBalance),
      callback: function($$v) {
        _vm.openingBalance = $$v
      },
      expression: "openingBalance"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "persistent-hint": "",
            "readlonly": "",
            "clearable": "",
            "placeholder": "yyyy-mm-dd",
            "hint": "Choose an invoice date, or leave blank to use the latest invoice date from the selected invoices",
            "label": "invoice date",
            "prepend-icon": "event"
          },
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.date_modal),
      callback: function($$v) {
        _vm.date_modal = $$v
      },
      expression: "date_modal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.date_modal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "persistent-hint": "",
            "readlonly": "",
            "clearable": "",
            "placeholder": "yyyy-mm-dd",
            "hint": "Choose a due date, or leave blank to use the latest invoice due date from the selected invoices",
            "label": "due date",
            "prepend-icon": "event"
          },
          model: {
            value: (_vm.due_date),
            callback: function($$v) {
              _vm.due_date = $$v
            },
            expression: "due_date"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.due_date_modal),
      callback: function($$v) {
        _vm.due_date_modal = $$v
      },
      expression: "due_date_modal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.date
    },
    model: {
      value: (_vm.due_date),
      callback: function($$v) {
        _vm.due_date = $$v
      },
      expression: "due_date"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.due_date_modal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": "",
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('subtitles.invoices')) + "\n    ")]), _vm._v(" "), _vm._l((_vm.invoices), function(invoice) {
    return [_c('v-list-tile', {
      key: invoice.id
    }, [_c('v-list-tile-action', {
      staticClass: "mr-2"
    }, [_vm._v("\n          #" + _vm._s(invoice.id) + "\n        ")]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "hidden-xs-only"
    }, [_vm._v("\n            " + _vm._s(invoice.title) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(invoice.date) + ".\n            "), _c('strong', [_vm._v("Due:")]), _vm._v(" " + _vm._s(invoice.due_date) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "hidden-xs-only mr-2"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, invoice.invoice_amount)))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.invoiced')) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "hidden-xs-only"
    }, [_vm._v("\n          " + _vm._s(_vm.formatCurrency(_vm.currency, invoice.amount_paid)) + "\n          "), _c('v-list-tile-action-text', [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.payments')) + "\n          ")])], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ml-2",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "grey lighten-4 px-1"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, (invoice.invoice_amount - invoice.amount_paid))))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.due')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(!_vm.showNotes) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showNotes = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          " + _vm._s(_vm.$t('buttons.note')) + "\n        ")], 1) : [_c('h4', {
    staticClass: "overline ml-1"
  }, [_vm._v(_vm._s(_vm.$t('subtitles.notes')))]), _vm._v(" "), _c('v-textarea', {
    staticClass: "ma-1 mr-2",
    attrs: {
      "filled": "",
      "box": "",
      "filled": "",
      "label": "Add a note"
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-right"
  }, [_c('v-flex', {
    staticClass: "text-uppercase",
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.opening')) + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.currency, _vm.openingBalance)))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-right"
  }, [_c('v-flex', {
    staticClass: "text-uppercase",
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.invoiced')) + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.currency, _vm.invoiceTotal)))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-right mb-2"
  }, [_c('v-flex', {
    staticClass: "text-uppercase",
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('subtitles.payments')) + "\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.currency, _vm.paymentsTotal)))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-right mt-2 subtitle-1 text-uppercase"
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm10": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('subtitles.total')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-right",
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('strong', [_vm._v("\n              " + _vm._s(_vm.formatCurrency(this.currency, _vm.grandTotal)) + "\n            ")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.noInvoices,
      "loading": _vm.statementRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.create')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2b845b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Statement/CreateStatementForm.vue
// module id = 1539
// module chunks = 9